// import RNLanguages from 'react-native-languages';
import i18n from "i18n-js";

import en from "./translations/en.json";
import fr from "./translations/fr.json";
import getLocale from "./utils/getLocale";

const currentLocale = getLocale();
// import de from './translations/de.json';

// i18n.locale = RNLanguages.language;
// i18n.locale = 'fr';
console.log("Device Locale", currentLocale);

i18n.locale = currentLocale;
i18n.fallbacks = true;
i18n.translations = { fr, en };

export default i18n;
